export default {
      id: "i-vtb-logo-usage",
      viewBox: "0 0 58 29",
      url: __webpack_public_path__ + "img/sprite.svg#i-vtb-logo",
      toString: function () {
        return this.url;
      }
    }